"use client";

import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import type { PropsWithChildren } from "react";

const FullAppExperience = dynamic(() =>
  import("./full-app-experience").then((m) => m.FullAppExperience),
);

export function AppExperience({ children }: PropsWithChildren) {
  const pathname = usePathname();
  return pathname.startsWith("/seller-onboarding/") ? (
    children
  ) : (
    <FullAppExperience>{children}</FullAppExperience>
  );
}
